'use client'

import { useState } from 'react'

import { QueryClientProvider as TanstackQueryClientProvider } from '@tanstack/react-query'

import { getQueryClient } from '@/query-client'

export const QueryClientProvider = ({
  children
}: {
  children: React.ReactNode
}) => {
  const [queryClient] = useState(getQueryClient())

  return (
    <TanstackQueryClientProvider client={queryClient}>
      {children}
    </TanstackQueryClientProvider>
  )
}
